import { createStore } from 'vuex'
import auth from '@/store/modules/auth'
import agents from '@/store/modules/agents'
import inboxes from '@/store/modules/inboxes'
import conversations from '@/store/modules/conversations'
import stats from '@/store/modules/stats'

export default createStore({
  modules: {
    auth,
    agents,
    inboxes,
    conversations,
    stats,
  },
})
